import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  modifyProduct,
  getProductsError,
  getProductsStatus,
  updateStatus,
  getProductsisLoading,
  getProductsSuccess,
} from "../../../features/productSlice";
import {
  selectAllCategories,
  fetchCategories,
} from "../../../features/categorySlice";
import { useLocation, useNavigate } from "react-router-dom";
import { getTypes, selectAllTypes } from "../../../features/typeSlice";
import {
  getTypeVariations,
  selectAllTypeVariations,
} from "../../../features/typeVariationSlice";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import ProductForm from "./productForm";
import BackButton from "../../../components/backButton";
import { getImageFormFields } from "../../../global/functions/imageHelper";
import { getAllergys, selectAllAllergys } from "../../../features/allergySlice";
import { useTranslation } from "react-i18next";
const ModifyProduct = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { restaurantId } = useRestaurant();
  const location = useLocation();
  const data = location.state.product || {};
  const categoryId = location.state.categoryId;
  const categoryName = location.state.categoryName;
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedTypes, setSelectedTypes] = useState(
    Array.isArray(data?.type)
      ? data.type.map((typ) => ({ name: typ.name, _id: typ._id }))
      : []
  );
  const status = useSelector(getProductsStatus);
  const error = useSelector(getProductsError);
  const loading = useSelector(getProductsisLoading);
  const success = useSelector(getProductsSuccess);
  const typesWithIngrediants = useSelector(selectAllTypes);
  const categories = useSelector(selectAllCategories);
  const typeVariation = useSelector(selectAllTypeVariations);
  const allergies = useSelector(selectAllAllergys);

  const initialValues = {
    name: data.name,
    description: data.description || "",
    categories: (() => {
      if (Array.isArray(data.categories) && data.categories.length > 0) {
        return data.categories.map((cat) =>
          typeof cat === "object" ? cat._id : cat
        );
      }
      if (data.category) {
        return [
          typeof data.category === "string" ? data.category : data.category._id,
        ];
      }
      return data.categories || [];
    })(),
    allergies: Array.isArray(data.allergies)
    ? data.allergies.map((allergy) =>
        typeof allergy === "object" ? allergy._id : allergy
      )
    : [],
    price: data.originalPrice || data.price,
    formulePrice: data.formulePrice || 0,
    outOfStock: data.outOfStock,
    visible: data.visible,
    choice: data.choice,
    type: data.type || [],
    variations:
      data.typeVariations?.variations?.map((v) => {
        const selectedType = typeVariation.find(
          (t) => t._id === data.typeVariations.typeVariation
        );
        const variationDetail = selectedType?.variations.find(
          (variant) => variant._id === v._id
        );

        return {
          _id: v._id,
          variation: v._id,
          typeVariation: data.typeVariations.typeVariation,
          name: variationDetail
            ? `${selectedType.name} ${variationDetail.name}`
            : "",
          price: v.price || 0,
        };
      }) || [],
    typeVariation: data.typeVariations?.typeVariation || "",
    discountValue: data.discountValue ? data.discountValue : null,
    discountStartDate: data.discountStartDate
      ? new Date(data.discountStartDate)
      : null,
    discountEndDate: data.discountEndDate
      ? new Date(data.discountEndDate)
      : null,
    tva: data?.tva || 0,
  };

  const handleFormSubmit = (values) => {
    const selectedTypeIds = selectedTypes.map((type) => type._id);
    const requestBody = {
      name: values.name,
      description: values.description,
      price: values.price,
      formulePrice: values.formulePrice,
      // category: values.category,
      categories: values.categories,
      allergies: values.allergies,
      choice: values.choice,
      outOfStock: values.outOfStock,
      visible: values.visible,
      ...getImageFormFields(previewImage),
      type: JSON.stringify(selectedTypeIds),
      variations: values.variations.map((v) => ({
        _id: v.variation,
        price: v.price,
      })),
      typeVariation: values.typeVariation,
      discountValue: values.discountValue,
      discountStartDate: values.discountStartDate,
      discountEndDate: values.discountEndDate,
      tva: values.tva,
    };
    dispatch(
      modifyProduct({
        body: requestBody,
        productId: data._id,
        restaurantId: restaurantId,
      })
    );
  };

  const handleTypeSelect = (event) => {
    const selectedTypeIds = event.target.value;
    const newSelectedTypes = typesWithIngrediants.filter((type) =>
      selectedTypeIds.includes(type._id)
    );
    setSelectedTypes(newSelectedTypes);
  };

  useEffect(() => {
    dispatch(getTypeVariations(restaurantId));
    dispatch(getTypes(restaurantId));
    dispatch(fetchCategories(restaurantId));
    dispatch(getAllergys());
  }, [dispatch, restaurantId]);

  useEffect(() => {
    if (status === "modifySuccess") {
      toast.success(success);
      dispatch(updateStatus());
      navigate("/products", {
        state: { categoryId: categoryId, categoryName: categoryName },
      });
    } else if (status === "modifyError") {
      toast.error(error);
    }
  }, [
    status,
    error,
    dispatch,
    navigate,
    success,
    categoryId,
    categoryName,
    restaurantId,
    categories,
  ]);

  return (
    <Box m="20px" className="main-application">
      <BackButton />
      <Header title={t("headers.editProduct")} subtitle={t("headers.editProductSub")} />
      <ProductForm
        buttonText={t("common.edit")}
        handleFormSubmit={handleFormSubmit}
        initialValues={initialValues}
        categories={categories}
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
        selectedTypes={selectedTypes}
        handleTypeSelect={handleTypeSelect}
        typesWithIngrediants={typesWithIngrediants}
        typeVariation={typeVariation}
        setSelectedTypes={setSelectedTypes}
        loading={loading}
        image={data.image}
        allergies={allergies}
      />
    </Box>
  );
};

export default ModifyProduct;
